import { ComponentLookup } from '../ComponentLookup';
import { CfgUIElementState } from '../../../stores/CfgUIElementState';
import { AttributeLookup } from './AttributeLookup';
import { ProductLookup } from '@/ui-kit/domain/lookup/ProductLookup';

export function componentLookupBehaviour(lookup: ComponentLookup, state: CfgUIElementState) {
  lookup.setValueSelectListener((visible) => {
    state.notify({
      event: 'changeComponentAttributesVisibility',
      visible,
      componentKey: lookup.componentKey,
      target: state,
    });
    state.notify({
      event: 'updateDependentAttributes',
      attributes: [],
      target: state,
    });
  });
}

export function attributeLookupBehaviour(lookup: AttributeLookup | ProductLookup, state: CfgUIElementState) {
  lookup.setValueSelectListener((value) => {
    state.notify({
      event: 'updateDependentAttributes',
      attributes: [],
      target: state,
    });
  });
}
